export default "/images/borderlands-echovision-logo@2x.png";